var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIcondashboardaddUnit = function SvgIcondashboardaddUnit(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Dashboard/icon.dashboard.add_unit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Dashboard/icon.dashboard.add_unit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5,2.81818182 C32.0128358,2.81818182 32.4355072,3.20422201 32.4932723,3.70156069 L32.5,3.81818182 L32.5,29.5 L59.1805556,29.5 C59.7328403,29.5 60.1805556,29.9477153 60.1805556,30.5 C60.1805556,31.0128358 59.7945154,31.4355072 59.2971767,31.4932723 L59.1805556,31.5 L32.5,31.5 L32.5,56.1818182 C32.5,56.7341029 32.0522847,57.1818182 31.5,57.1818182 C30.9871642,57.1818182 30.5644928,56.795778 30.5067277,56.2984393 L30.5,56.1818182 L30.5,31.5 L1.81944444,31.5 C1.26715969,31.5 0.819444444,31.0522847 0.819444444,30.5 C0.819444444,29.9871642 1.20548463,29.5644928 1.70282332,29.5067277 L1.81944444,29.5 L30.5,29.5 L30.5,3.81818182 C30.5,3.26589707 30.9477153,2.81818182 31.5,2.81818182 Z",
    id: "Combined-Shape",
    fill: "#C0C0C0",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIcondashboardaddUnit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.dashboard.add_unit.1e891436c607b3811c37b3abe6c32032.svg";